import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiPlayCircle, FiUsers, FiRadio, FiGlobe } from 'react-icons/fi';

const SignalCard = ({ title, description, icon: Icon, delay }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.95 }}
    whileInView={{ opacity: 1, scale: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 0.4, delay }}
    className="bg-white rounded-xl p-5 shadow-soft border border-dc-teal-deep/5 hover:border-dc-teal-signal/20 transition-colors duration-300"
  >
    <div className="flex items-start gap-3">
      <div className="w-10 h-10 bg-dc-teal-signal/10 rounded-lg flex items-center justify-center flex-shrink-0">
        <SafeIcon icon={Icon} className="w-5 h-5 text-dc-teal-signal" />
      </div>
      <div>
        <h3 className="font-semibold text-dc-teal-deep mb-1 text-sm">{title}</h3>
        <p className="text-dc-text/70 text-xs leading-relaxed">{description}</p>
      </div>
    </div>
  </motion.div>
);

const SponsoredSignalSystem = () => {
  const signals = [
    {
      title: 'AI Mastermind',
      description: 'Recording, speaker takeaways, and strategic breakdowns become the intelligence layer.',
      icon: FiPlayCircle
    },
    {
      title: 'AI Smart Connect',
      description: 'Conversations around AI, business, and reputation connect back to RepUpgrade.',
      icon: FiUsers
    },
    {
      title: 'Frequency Smart Connect',
      description: 'Frequency-based clarity connects to the Frequency Finder app.',
      icon: FiRadio
    },
    {
      title: 'AI Business Consultant Directory',
      description: 'Member profiles, sponsorship visibility, and network signal become searchable online.',
      icon: FiGlobe
    }
  ];

  return (
    <section className="py-16 px-6 max-w-5xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="text-center mb-12"
      >
        <h2 className="text-2xl md:text-3xl font-bold text-dc-teal-deep mb-4">
          The Sponsored Signal System
        </h2>
        <p className="text-dc-text/80 max-w-3xl mx-auto leading-relaxed">
          RepUpgrade sponsors the ecosystem: the Mastermind creates the intelligence, Smart Connects create the conversations, Frequency Finder sharpens personal clarity, and the Directory gives member work a searchable home.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {signals.map((signal, idx) => (
          <SignalCard
            key={idx}
            title={signal.title}
            description={signal.description}
            icon={signal.icon}
            delay={idx * 0.1}
          />
        ))}
      </div>
    </section>
  );
};

export default SponsoredSignalSystem;